"use client"

import { Dialog, DialogContent, DialogMenuButton, DialogTrigger } from "@/components"
import { IconButton } from "@/elements"
import { BellIcon, BellSlashIcon, EllipsisVerticalIcon, EyeIcon, EyeSlashIcon } from "@heroicons/react/24/outline"
import React, { FC } from "react"
import { Channel } from "stream-chat"

interface Props {
  channel: Channel
  onMute: (muted: boolean) => void
  isMuted: boolean
  onArchive: (archived: boolean) => void
  isArchived: boolean
}

export const ChannelOptionsDialog: FC<Props> = ({ channel, onMute, isMuted, onArchive, isArchived }) => {
  const [isOpen, setIsOpen] = React.useState(false)
  const handleMuteChat = async () => {
    if (isMuted) {
      await channel?.unmute()
      onMute(channel?.muteStatus().muted ?? false)
    } else {
      await channel?.mute()
      onMute(channel?.muteStatus().muted ?? false)
    }
    setIsOpen(false)
  }

  const handleArchiveChat = async () => {
    if (isArchived) {
      await channel?.show()
      onArchive(Boolean(channel?.data?.hidden) ?? false)
    } else {
      await channel?.hide()
      onArchive(Boolean(channel?.data?.hidden) ?? false)
    }
    setIsOpen(false)
  }

  const handleCancel = () => {
    setIsOpen(false)
  }

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <div className="flex flex-shrink-0">
          <IconButton variant="white" Icon={EllipsisVerticalIcon} onClick={() => setIsOpen(true)} />
        </div>
      </DialogTrigger>

      <DialogContent withClose={false} className="w-[400px]" fullScreenOnMobile={false}>
        <div className="w-[400px]! p-2 max-modal-size">
          <DialogMenuButton
            title={isMuted ? "Unmute chat" : "Mute chat"}
            onClick={handleMuteChat}
            Icon={isMuted ? BellIcon : BellSlashIcon}
          />
          <DialogMenuButton
            title={isArchived ? "Unarchive chat" : "Archive chat"}
            onClick={handleArchiveChat}
            Icon={isArchived ? EyeIcon : EyeSlashIcon}
            color={isArchived ? "black" : "red"}
          />
          <DialogMenuButton title="Cancel" onClick={handleCancel} />
        </div>
      </DialogContent>
    </Dialog>
  )
}
